<script setup lang="ts">
import { RouterView } from 'vue-router';
import { onBeforeMount, onMounted, watch } from 'vue';
import { useStorage  } from '@vueuse/core';
import { useAuthStore } from './store/auth';
import { useQueryStore } from './store/query';
import { router } from './router';
import { FetchFormats } from './services/LegacyConversionService';
import { useMimeStore } from './store/mime';

onBeforeMount(() => {
  const preferences = useStorage('preferences', {theme: 'slate'}, localStorage);
  document.documentElement.setAttribute('data-theme', preferences.value.theme);
})

// keep selected filters in sync with url
const { 
  selectedFilterMap, 
  convertFiltersToUrlQuerySyntax, 
  getQuery, 
  getSortField, 
  getSortDir,
  getPlace,
  getIntersects
} = useQueryStore();
watch([selectedFilterMap, getQuery, getSortField, getSortDir, getPlace, getIntersects], 
([newFilters, newQuery, newSortField, newSortDir, newPlace, newIntersects]) => {
  const filterQueries = convertFiltersToUrlQuerySyntax(newFilters)
  const q = newQuery?.trim() === '' ? undefined : newQuery;
  const place = newPlace?.trim() === '' ? undefined : newPlace;
  const intersects = (newIntersects === undefined || place === undefined) ? undefined : newIntersects;
  const nextRoute: any = {name: 'search', query: {
    fq: filterQueries, 
    q,
    sort: newSortField,
    dir: newSortDir,
    place
  }};
  if(intersects !== undefined) { nextRoute.query.intersects = intersects }
  router.push(nextRoute);
}, {deep: true});

const { setMimeType, state: mimeStore } = useMimeStore();

onMounted(async () => {
  const {
    setUserName,
    setThumbURL,
    fetchUser
  } = useAuthStore();

  
  if(mimeStore.size === 0) {
    const formats: Record<string, string> = await FetchFormats();
    Object.keys(formats).forEach((key) => {
      setMimeType(key, formats[key]);
    });
  }

  setUserName('Guest');
  setThumbURL('https://source.boringavatars.com/beam/?colors=eb7f7f,eb9a7f,ebb57f,ebd07f,ebeb7f');
  await fetchUser();
})
</script>

<template>
  <RouterView v-slot="{ Component }">
    <transition>
      <KeepAlive>
        <component :is="Component"/>
      </KeepAlive>
    </transition>
  </RouterView>
</template>

<style>

#app {
  font-family: Montserrat, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  /* background-color: rgb(46, 46, 58); */
  background-color: var(--app-background)
}
.home-layout{
  display: grid;
  grid-template-areas: "searchBar";
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
